import api, { authHeader } from '../config/api'

export const izipayServices = {
    generateToken: (data = {}) =>
        api.post('/api/MiCuenta/GenerarTokenIziPago', data, { headers: authHeader() }),
    generateAffiliate: (data = {}) =>
        api.post('/api/MiCuenta/GenerarTokenIziAfiliacion', data, { headers: authHeader() }),
}